<template>
  <div v-if="isRouterAlive" @click="navClick">
    <!-- 大屏幕 -->
    <div
      class="c-nav-wide c-nav-container unselect sticky"
      @mouseleave="unvisible"
    >
      <div
        :class="`home-nav c-nav flex ${
          navEnable || visible1 || visible2 || visible3 || visible4
            ? ''
            : 'navEnable'
        }`"
      >
        <b-img
          class="c-nav-logo"
          src="https://buzhistu-1251664918.cos.ap-shanghai.myqcloud.com/tianxin/logo.svg"
          @click="homeClick"
        />
        <div class="c-nav-menu-container flex">
          <div
            :class="`c-nav-menu ${visible1 ? 'active' : ''}`"
            @mouseenter="visible(1)"
          >
            <span>{{ $t("solutionbigtitle") }}</span>
          </div>
          <div
            :class="`c-nav-menu ${visible2 ? 'active' : ''}`"
            @mouseenter="visible(2)"
          >
            <span>{{ $t("newsbigtitle") }}</span>
          </div>
          <div
            :class="`c-nav-menu ${visible3 ? 'active' : ''}`"
            @mouseenter="visible(3)"
          >
            <span>{{ $t("aboutbigtitle") }}</span>
          </div>
          <div
            :class="`c-nav-menu ${visible4 ? 'active' : ''}`"
            @mouseenter="visible(4)"
          >
            <span>{{ $t("contactbigtitle") }}</span>
          </div>
        </div>
        <span class="c-nav-lang" @click="changeLan">
          <b-img
            src="https://wxapp-1304693027.cos.ap-shanghai.myqcloud.com/test/lan-01.svg"
          />
          {{ $t("nav.language") }}
          <!-- {{lan=='中文'?'简体中文':'ENGLISH'}} -->
        </span>
        <b-img
          @click="visible(5)"
          class="c-nav-search"
          src="https://wxapp-1304693027.cos.ap-shanghai.myqcloud.com/test/search-01.svg"
        />
      </div>
      <div v-if="visible1" class="c-nav-body">
        <b-container>
          <b-row>
            <b-col cols="3">
              <div>
                <div class="nav-body-title">{{ $t("solutionhosetitle") }}</div>
                <div
                  class="nav-body-subtitle"
                  v-for="(item, index) in JSON.parse($t('productlist1'))"
                  v-bind:key="index"
                  @click="routerClick('/product?type=0&category='+index)"
                >
                  <span>{{ item }}</span>
                </div>
              </div>
            </b-col>
            <b-col cols="3">
              <div>
                <div class="nav-body-title">{{ $t("solutionmetertitle") }}</div>
                <div
                  class="nav-body-subtitle"
                  v-for="(item, index) in JSON.parse($t('productlist2'))"
                  v-bind:key="index"
                  @click="routerClick('/product?type=1&category='+index)"
                >
                  <span>{{ item }}</span>
                </div>
              </div>
            </b-col>
            <b-col cols="3">
              <div>
                <div class="nav-body-title">
                  {{ $t("solutionsolutiontitle") }}
                </div>
                 <div
                  class="nav-body-subtitle"
                  v-for="(item, index) in JSON.parse($t('productlist3'))"
                  v-bind:key="index"
                  @click="routerClick('/product?type=2&category='+index)"
                >
                  <span>{{ item }}</span>
                </div>
                <!-- <div class="nav-body-subtitle" @click="routerClick('/product')">
                  <span>{{ $t("solutionsolutionhosesolution") }}</span>
                </div>
                <div class="nav-body-subtitle" @click="routerClick('/product')">
                  <span>{{ $t("solutionsolutionmetersolution") }}</span>
                </div> -->
              </div></b-col
            >
          </b-row>
        </b-container>
      </div>
      <div v-if="visible2" class="c-nav-body">
        <b-container>
          <b-row>
            <b-col cols="3">
              <div>
                <div class="nav-body-title">{{ $t("newsnewstitle") }}</div>
                <div class="nav-body-subtitle" @click="routerClick('/news?sort=0')">
                  <span>{{ $t("newsnewst1text") }}</span>
                </div>
                <div class="nav-body-subtitle" @click="routerClick('/news?sort=1')">
                  <span>{{ $t("newsnewst2text") }}</span>
                </div>
                <div class="nav-body-subtitle" @click="routerClick('/news?sort=2')">
                  <span>{{ $t("newsnewst3text") }}</span>
                </div>
                <div class="nav-body-subtitle" @click="routerClick('/news?sort=3')">
                  <span>{{ $t("newsnewst4text") }}</span>
                </div>
              </div>
            </b-col>
            <b-col cols="3">
              <div>
                <div class="nav-body-title">{{ $t("newsmovietitle") }}</div>
                <div class="nav-body-subtitle" @click="routerClick('/news2')">
                  <span>{{ $t("newsmoviet1text") }}</span>
                </div>
                <div class="nav-body-subtitle" @click="routerClick('/news3')">
                  <span>{{ $t("newsmoviet2text") }}</span>
                </div>
                <div class="nav-body-subtitle" @click="routerClick('/news4')">
                  <span>{{ $t("newsmoviet3text") }}</span>
                </div>
                <div class="nav-body-subtitle" @click="routerClick('/news5')">
                  <span>{{ $t("newsmoviet4text") }}</span>
                </div>
              </div>
            </b-col>
            <b-col cols="3">
              <div>
                <div class="nav-body-logo">
                  <b-img :src="$t('newsimg')" />
                </div></div
            ></b-col>
          </b-row>
        </b-container>
      </div>
      <div v-if="visible3" class="c-nav-body">
        <b-container>
          <b-row>
            <b-col cols="3">
              <div>
                <div class="nav-body-title">{{ $t("aboutbannertitle") }}</div>
                <b-row>
                  <b-col>
                    <div
                      class="nav-body-subtitle"
                      @click="routerClick('/about?sort=0')"
                    >
                      <span>{{ $t("aboutbannert1text") }}</span>
                    </div>
                    <div
                      class="nav-body-subtitle"
                      @click="routerClick('/about?sort=1')"
                    >
                      <span>{{ $t("aboutbannert2text") }}</span>
                    </div>
                    <div
                      class="nav-body-subtitle"
                      @click="routerClick('/about?sort=2')"
                    >
                      <span>{{ $t("aboutbannert3text") }}</span>
                    </div>
                    <div
                      class="nav-body-subtitle"
                      @click="routerClick('/about?sort=3')"
                    >
                      <span>{{ $t("aboutbannert4text") }}</span>
                    </div>
                    <div
                      class="nav-body-subtitle"
                      @click="routerClick('/about?sort=4')"
                    >
                      <span>{{ $t("aboutbannert5text") }}</span>
                    </div>
                    <div
                      class="nav-body-subtitle"
                      @click="routerClick('/about?sort=5')"
                    >
                      <span>{{ $t("aboutbannert6text") }}</span>
                    </div>
                    <div
                      class="nav-body-subtitle"
                      @click="routerClick('/about?sort=6')"
                    >
                      <span>{{ $t("aboutbannert7text") }}</span>
                    </div>
                  </b-col>
                  <b-col>
                    <div
                      class="nav-body-subtitle"
                      @click="routerClick('/about?sort=7')"
                    >
                      <span>{{ $t("aboutbannert8text") }}</span>
                    </div>
                    <div
                      class="nav-body-subtitle"
                      @click="routerClick('/about?sort=8')"
                    >
                      <span>{{ $t("aboutbannert9text") }}</span>
                    </div>
                    <!-- <div
                      class="nav-body-subtitle"
                      @click="routerClick('/news')"
                    >
                      <span>{{ $t("aboutbannert10text") }}</span>
                    </div> -->
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col cols="3">
              <div>
                <div class="nav-body-title">{{ $t("aboutemploytitle") }}</div>

                <div class="nav-body-subtitle" v-for="(item,index) in JSON.parse($t('aboutemploylist'))"  
              v-bind:key="index" @click="routerClick('/joinus')">
                  <span>{{ item }}</span>
                </div>
              </div>
            </b-col>
            <b-col cols="3">
              <div>
                <div class="nav-body-logo">
                  <b-img :src="$t('aboutimg')" />
                </div></div
            ></b-col>
          </b-row>
        </b-container>
      </div>
      <div v-if="visible4" class="c-nav-body">
        <b-container>
          <b-row>
            <b-col cols="3">
              <div>
                <div class="nav-body-title">
                  {{ $t("contactcontacttitle") }}
                </div>

                <!-- <div
                  class="nav-body-subtitle"
                  @click="routerClick($t('contactcontactt1url'))"
                >
                  <span>{{ $t("contactcontactt1text") }}</span>
                </div> -->
                <div
                  class="nav-body-subtitle"
                  @click="routerClick($t('contactcontactt2url'))"
                >
                  <span>{{ $t("contactcontactt2text") }}</span>
                </div>
              </div>
            </b-col>
            <b-col cols="3">
              <div>
                <div class="nav-body-title">
                  {{ $t("contacttechnologytitle") }}
                </div>

                <div
                  class="nav-body-subtitle"
                  @click="routerClick($t('contacttechnologyt1url'))"
                >
                  <span>{{ $t("contacttechnologyt1text") }}</span>
                </div>
                <div
                  class="nav-body-subtitle"
                  @click="routerClick($t('contacttechnologyt2url'))"
                >
                  <span>{{ $t("contacttechnologyt2text") }}</span>
                </div>
              </div>
            </b-col>
            <b-col cols="3">
              <div>
                <div class="nav-body-logo">
                  <b-img :src="$t('contactimg')" />
                </div></div
            ></b-col>
          </b-row>
        </b-container>
      </div>

      <div
        v-if="visible5"
        class="c-nav-body-search flex"
        style="position: fixed; top: 0"
      >
        <b-img
          class="c-nav-logo"
          src="https://buzhistu-1251664918.cos.ap-shanghai.myqcloud.com/tianxin/logo.svg"
          @click="homeClick"
        />
        <b-col md="6">
          <b-form-input
            class="c-nav-search-input"
            v-model="searchText"
            :placeholder="$t('nav.search')"
          ></b-form-input>
        </b-col>
      </div>
    </div>

    <!-- 小屏幕 -->
    <div class="c-nav-thin c-nav-thin-container unselect sticky">
      <div
        :class="`nav-thin-row ${
          navEnable || visible6 || bodyClick ? '' : 'navEnable'
        }`"
      >
        <b-img
          @click="homeClick"
          class="nav-thin-logo"
          src="https://buzhistu-1251664918.cos.ap-shanghai.myqcloud.com/tianxin/logo.svg"
        />
        <b-img
          @click="collposeV6"
          class="nav-thin-menu"
          :src="
            visible6
              ? 'https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/nav-fall.svg'
              : navEnable
              ? 'https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/nav-black.svg'
              : 'https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/nav-white.svg'
          "
        />
      </div>
      <b-collapse v-model="visible6" class="nav-thin-body">
        <div class="nav-thin-click">
          <div class="nav-thin-click-head" @click="collpose(1)">
            <span>{{ $t("solutionbigtitle") }}</span>
            <b-img
              :src="
                visible61
                  ? 'https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/nav-title-b.svg'
                  : 'https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/nav-title-a.svg'
              "
            />
          </div>
          <b-collapse
            v-model="visible61"
            :class="visible61 ? 'nav-thin-body2' : 'nav-thin-body2-noline'"
          >
            <div class="nav-thin-click-sub" @click="routerClick($t('solutionhoseurl'))">
              {{ $t("solutionhosetitle") }}
            </div>

            <div class="nav-thin-click-sub" @click="routerClick($t('solutionmeterurl'))">
              {{ $t("solutionmetertitle") }}
            </div>

            <div class="nav-thin-click-sub" @click="routerClick($t('solutionsolutionurl'))">
              {{ $t("solutionsolutiontitle") }}
            </div>
          </b-collapse>
        </div>
        <div class="nav-thin-click">
          <div class="nav-thin-click-head" @click="collpose(2)">
            <span>{{ $t("newsbigtitle") }}</span>
            <b-img
              :src="
                visible62
                  ? 'https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/nav-title-b.svg'
                  : 'https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/nav-title-a.svg'
              "
            />
          </div>
          <b-collapse
            v-model="visible62"
            :class="visible62 ? 'nav-thin-body2' : 'nav-thin-body2-noline'"
          >
            <div class="nav-thin-click-sub" @click="routerClick($t('newsnewsurl'))">
              {{ $t("newsnewstitle") }}
            </div>
            <div class="nav-thin-click-sub" @click="routerClick($t('newsmovieurl'))">
              {{ $t("newsmovietitle") }}
            </div>
          </b-collapse>
        </div>
        <div class="nav-thin-click">
          <div class="nav-thin-click-head" @click="collpose(3)">
            <span>{{ $t("aboutbigtitle") }}</span>
            <b-img
              :src="
                visible63
                  ? 'https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/nav-title-b.svg'
                  : 'https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/nav-title-a.svg'
              "
            />
          </div>
          <b-collapse
            v-model="visible63"
            :class="visible63 ? 'nav-thin-body2' : 'nav-thin-body2-noline'"
          >
            <div class="nav-thin-click-sub" @click="routerClick($t('aboutbannerurl'))">
              {{ $t("aboutbannertitle") }}
            </div>
            <div class="nav-thin-click-sub" @click="routerClick($t('aboutemployurl'))">
              {{ $t("aboutemploytitle") }}
            </div>
          </b-collapse>
        </div>
        <div class="nav-thin-click">
          <div class="nav-thin-click-head" @click="collpose(4)">
            <span>{{ $t("contactbigtitle") }}</span>
            <b-img
              :src="
                visible64
                  ? 'https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/nav-title-b.svg'
                  : 'https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/nav-title-a.svg'
              "
            />
          </div>
          <b-collapse
            v-model="visible64"
            :class="visible64 ? 'nav-thin-body2' : 'nav-thin-body2-noline'"
          >
            <div
              class="nav-thin-click-sub"
              @click="routerClick($t('contactcontactt1url'))"
            >
              {{ $t("contactcontacttitle") }}
            </div>
            <div
              class="nav-thin-click-sub"
              @click="routerClick($t('contacttechnologyt1url'))"
            >
              {{ $t("contacttechnologytitle") }}
            </div>
          </b-collapse>
        </div>

        <div class="nav-thin-lan">
          <b-img
            src="https://wxapp-1304693027.cos.ap-shanghai.myqcloud.com/test/lan-01.svg"
          />
          <div class="nav-thin-lang" @click="changeLan">
            {{ $i18n.locale == "zh" ? "(CHINA)" : "(英文)"
            }}{{ $t("nav.language") }}
          </div>
        </div>
      </b-collapse>
    </div>
    <div
      v-if="visible1 || visible2 || visible3 || visible4 || visible5"
      class="body-shadow"
    ></div>
  </div>
</template>

<script>
export default {
  name: "Navbar",

  props: {
    mode: {
      type: String,
      value: "homepage",
    },
  },
  data() {
    return {
      isRouterAlive: true,

      search: false,
      searchText: "",
      visible1: false,
      visible2: false,
      visible3: false,
      visible4: false,
      visible5: false,

      visible6: false,
      visible61: false,
      visible62: false,
      visible63: false,
      visible64: false,

      lan: "中文",
    };
  },
  computed: {
    navEnable() {
      return this.$store.state.navEnable;
    },
    bodyClick() {
      return this.$store.state.bodyClick;
    },
    pipeseriesList() {
      return this.$store.state.product1List;
    },
    appearenaceList() {
      return this.$store.state.product2List;
    },
    solutionList() {
      return this.$store.state.solutionList;
    },
    newsList() {
      return this.$store.state.newsList;
    },
    mediaList() {
      return this.$store.state.mediaList;
    },
    bandList1() {
      return this.$store.state.bandList1;
    },
    bandList2() {
      return this.$store.state.bandList2;
    },
    zhaoxianList() {
      return this.$store.state.zhaoxianList;
    },
    contactList() {
      return this.$store.state.contactList;
    },
    supportList() {
      return this.$store.state.supportList;
    },
    navList() {
      return [
        {
          title: "产品及解决方案",
          list: [
            { title: "天鑫软管", url: "/product" },
            { title: "天鑫仪表", url: "/product" },
            { title: "解决方案", url: "/product" },
          ],
        },
        {
          title: "新闻&媒体",
          list: [
            { title: "新闻", url: "/news" },
            { title: "媒体", url: "/news2" },
          ],
        },
        {
          title: "关于天鑫",
          list: [
            { title: "品牌介绍", url: "/about" },
            { title: "招贤纳士", url: "/joinus" },
          ],
        },
        {
          title: "联系我们",
          list: [
            { title: "采购与咨讯", url: "/contact" },
            { title: "技术支持", url: "/contact" },
          ],
        },
      ];
    },
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    getNav() {
      const _this = this;
      this.$store.dispatch("getNav").then(({ zh, en }) => {
        console.log("zh", zh);
        _this.$i18n.mergeLocaleMessage("en", en);
        _this.$i18n.mergeLocaleMessage("zh", zh);
        _this.reload();
      });
    },
    navbarMouseEnter() {
      // eslint-disable-next-line
      if (vm.scrollTop == 0) {
        this.mode = "navbar-light bg-light nav-b";
      }
    },
    navbarMouseLeave() {
      // eslint-disable-next-line
      if (vm.scrollTop == 0) {
        this.mode = "homepage";
      }
    },
    searchMouseEnter() {
      this.search = true;
    },
    searchMouseLeave() {
      this.search = false;
    },
    productMouseEnter(e) {
      console.log(e);
    },
    homeClick() {
      this.$router.push("/");
      this.visible1 = false;
      this.visible2 = false;
      this.visible3 = false;
      this.visible4 = false;
      this.visible5 = false;
    },
    routerClick(url) {
      console.log(url);
      this.visible1 = false;
      this.visible2 = false;
      this.visible3 = false;
      this.visible4 = false;
      this.visible5 = false;
      this.visible6 = false;
      this.$router.push({path:url});
      // window.location.href=url
      // this.$router.push({ path: '/contact', params: { p: 'z' }})
      // this.$router.push({ path: "/contact", params: { p: "z" } });
    },
    unvisible() {
      this.visible1 = false;
      this.visible2 = false;
      this.visible3 = false;
      this.visible4 = false;
      this.visible5 = false;
    },
    collposeV6() {
      this.visible6 = !this.visible6;
      this.$store.state.navEnable = this.visible6;

      this.visible61 = false;
      this.visible62 = false;
      this.visible63 = false;
      this.visible64 = false;
    },
    collpose(i) {
      switch (i) {
        case 1:
          if (this.visible61) {
            this.visible61 = false;
            this.visible62 = false;
            this.visible63 = false;
            this.visible64 = false;
          } else {
            this.visible61 = true;
            this.visible62 = false;
            this.visible63 = false;
            this.visible64 = false;
          }
          break;
        case 2:
          if (this.visible62) {
            this.visible61 = false;
            this.visible62 = false;
            this.visible63 = false;
            this.visible64 = false;
          } else {
            this.visible61 = false;
            this.visible62 = true;
            this.visible63 = false;
            this.visible64 = false;
          }
          break;
        case 3:
          if (this.visible63) {
            this.visible61 = false;
            this.visible62 = false;
            this.visible63 = false;
            this.visible64 = false;
          } else {
            this.visible61 = false;
            this.visible62 = false;
            this.visible63 = true;
            this.visible64 = false;
          }
          break;
        case 4:
          if (this.visible64) {
            this.visible61 = false;
            this.visible62 = false;
            this.visible63 = false;
            this.visible64 = false;
          } else {
            this.visible61 = false;
            this.visible62 = false;
            this.visible63 = false;
            this.visible64 = true;
          }
          break;
      }
    },
    visible(i) {
      switch (i) {
        case 1:
          this.visible1 = true;
          this.visible2 = false;
          this.visible3 = false;
          this.visible4 = false;
          this.visible5 = false;
          break;
        case 2:
          this.visible1 = false;
          this.visible2 = true;
          this.visible3 = false;
          this.visible4 = false;
          this.visible5 = false;
          break;
        case 3:
          this.visible1 = false;
          this.visible2 = false;
          this.visible3 = true;
          this.visible4 = false;
          this.visible5 = false;
          break;
        case 4:
          this.visible1 = false;
          this.visible2 = false;
          this.visible3 = false;
          this.visible4 = true;
          this.visible5 = false;
          break;
        case 5:
          this.visible1 = false;
          this.visible2 = false;
          this.visible3 = false;
          this.visible4 = false;
          this.visible5 = true;
          break;
      }
    },
    navClick() {
      this.$store.state.navClick = true;
      console.log("navclick", this.$store.state.navClick);
    },
    changeLan() {
      let lang = this.$i18n.locale === "zh" ? "en" : "zh";
      this.$i18n.locale = lang;
    localStorage.setItem('lang',lang)
    },
  },
  mounted() {
    this.getNav();
  },
};
</script>
<style>
.c-nav-thin {
  display: none;
}
.c-nav-container {
  z-index: 1702;
}
.c-nav {
  z-index: 1702;
  height: 75px;
  background-color: #ffffff;
  position: relative;
  border-bottom: 1px solid #a4a4a466;
}
.c-nav.navEnable {
  color: #888888;
  background-color: #ffffff00;
  border-bottom: 0px solid #a4a4a466;
}

.c-nav-logo {
  height: 45px;
  margin-left: 90px;
  margin-top: 15px;
  cursor: pointer;
}
.c-nav-menu-container {
  width: 60vw;
  margin-left: 5vw;
}
.c-nav-menu {
  margin: 0 2vw;
  white-space: nowrap;
  font-size: 20px;
  height: 75px;
  padding-top: 25px;
  cursor: pointer;
}
.c-nav-menu span {
  padding-bottom: 22px;
}

.c-nav-menu.active {
  padding-bottom: 22px;
  border-bottom: 2px solid #000;
}

.c-nav-lang {
  position: absolute;
  top: 30px;
  right: 80px;
  font-size: 15px;
  color: #888888;
  cursor: pointer;
}
.c-nav-lang img {
  width: 20px;
  height: 20px;
  margin-top: -2px;
}
.c-nav-search {
  width: 20px;
  height: 20px;
  top: 32px;
  position: absolute;
  right: 20px;
  cursor: pointer;
}
.c-nav-body {
  position: absolute;
  z-index: 1702;
  background-color: #fff;
  width: 100vw;
  top: 75px;
  padding-top: 30px;
  padding-bottom: 60px;
}
.nav-body-title {
  font-size: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #a4a4a466;
}

.nav-body-subtitle {
  font-size: 15px;
  font-weight: 200;
  color: #a4a4a4;
  margin-top: 10px;
}

.nav-body-subtitle span:hover {
  color: #000;
  border-bottom: 1px solid #000;
  cursor: pointer;
}
.nav-body-logo {
  margin-top: 35px;
  width: 100%;
}
.c-nav-body-search {
  position: absolute;
  top: 0;
  z-index: 1703;
  height: 75px;
  width: 100vw;
  background-color: #ffffff;
  position: relative;
  border-bottom: 1px solid #a4a4a466;
}
.c-nav-search2 {
  width: 20px;
  height: 20px;
  margin-top: 30px;
  /* margin-left: 5vw; */
}

.c-nav-body-search input {
  border: 0px solid #fff;
}
.c-nav-body-search input:active {
  border: 0px solid #fff;
}
.c-nav-body-search input:focus {
  border: 0px solid #fff;
}
.c-nav-body-search input::after {
  border: 0px solid #fff;
}
.c-nav-search-input {
  width: 50vw;
  margin-top: 20px;
  text-align: center;
}
.body-shadow {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 998;
  background-color: #000;
  opacity: 0.6;
}

@media only screen and (max-width: 1150px) {
  .c-nav-thin {
    display: block;
  }
  .c-nav-wide {
    display: none;
  }

  .nav-thin-row.navEnable {
    color: #888888;
    background-color: #ffffff00;
    border-bottom: 0px solid #a4a4a466;
  }
  .nav-thin-row {
    height: 55px;
    background-color: #fff;
    /* border-bottom: 1px solid #a4a4a466; */
  }
  .nav-thin-body {
    height: 100vh;
  }

  .nav-thin-body2-noline {
    border-bottom: 0px solid #a4a4a466;
  }
  .nav-thin-body2 {
    border-bottom: 1px solid #a4a4a466;
  }
  .nav-thin-row.navEnable {
    box-shadow: #88888800 0 5px 5px -5px;
  }
  .nav-thin-row {
    box-shadow: #888888 0 5px 5px -5px;
  }
  .c-nav-thin-container {
    position: relative;
    z-index: 1702;
    height: 55px;
    width: 100vw;
  }
  .nav-thin-logo {
    height: 25px;
    margin-left: 30px;
    margin-top: 15px;
    cursor: pointer;
  }
  .nav-thin-menu {
    position: absolute;
    top: 20px;
    height: 15px;
    right: 30px;
  }
  .nav-thin-body {
    padding-left: 30px;
    padding-top: 10px;
    padding-bottom: 50px;
    background-color: #fff;
    color: #888888;
    box-shadow: #aaaaaa44 0 -5px 5px -5px;
  }
  .nav-thin-click img {
    height: 15px;
    width: 15px;
    position: absolute;
    right: 30px;
    margin-top: 5px;
  }
  .nav-thin-click-head {
    padding: 25px 0;
    margin-right: 25px;
    border-bottom: 1px solid #a4a4a466;
  }
  .nav-thin-click-head span {
    color: #666666;
    font-weight: bold;
  }
  .nav-thin-click-sub {
    font-size: 15px;
    margin: 15px 0;
    color: #888888;
  }
  .nav-thin-lan {
    font-size: 12px;
    margin-left: -30px;
  }
  .nav-thin-lan img {
    width: 30px;
    height: 30px;
    margin-bottom: 20px;
  }
  .nav-thin-lan {
    text-align: center;
    margin-top: 100px;
    margin-bottom: 0px;
  }
}
</style>
